/**
 * 启动画面工具
 * 用于在 React 应用完全渲染后通知启动画面可以移除
 */

/**
 * 通知启动画面可以移除
 * 应在首屏内容完全加载后调用
 */
export function notifySplashReady(): void {
  // 通过自定义事件通知 index.html 中的脚本
  window.dispatchEvent(new CustomEvent('app-ready'));
  console.log('[Splash] App ready event dispatched');
}

/**
 * 检查启动画面是否存在
 */
export function isSplashVisible(): boolean {
  const splash = document.getElementById('splash-screen');
  return splash !== null && !splash.classList.contains('fade-out');
}
